import { useEffect, useState } from "react";
import { getFamily } from "../api-interactions/family";
import BarChart from "./barChart";
import "./pointLeaderboard.css";

const PointLeaderboard = () => {
  const [members, setMembers] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    (async function () {
      const members = await getFamily(user);
      setMembers(members);
    })();
  }, []);

  return (
    <div className="wide-list-container">
      <h2>Leaderboard</h2>
      <div className="chart-container">
        <BarChart members={members} />
      </div>
    </div>
  );
};

export default PointLeaderboard;
